angular.module('b2bLoginApp.directives').directive('editable', ["$uibModal", "CompanyProfilePublic", function ($uibModal, CompanyProfilePublic) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var controllerScope = scope;
            var editableTrackingIds = {
                about: 'pencil__about_the_company',
                qa: 'pencil__q_and_a',
                facts: 'pencil__company_facts',
                contact: 'pencil__contact_info'
            };

            element.on('click', function (event) {
                var trackingId = editableTrackingIds[attrs.editable];
                if (trackingId && scope.company) {
                    try {
                        window.SelfServiceGATracker.sendButtonClickEvent(trackingId, scope.company.id);
                    } catch (e) { /* tracker not loaded */ }
                }

                var modal = $uibModal.open({
                    templateUrl: '/account/company-profile-public/edit-' + attrs.editable + '.html',
                    scope: scope,
                    backdrop: 'static',
                    keyboard: false,
                    openedClass: 'company-profile-modal modal-open',
                    controller: ["$scope", function ($scope) {

                        $scope.getField = function (field) {
                            return $scope.form[field];
                        };

                        $scope.isInvalid = function (name) {
                            var field = $scope.getField(name);
                            if (typeof field === 'undefined') {
                                return false;
                            } else {
                                return field.$invalid;
                            }
                        };

                        $scope.getErrorForField = function (field) {
                            if (typeof $scope.form[field] !== 'undefined' &&
                                typeof $scope.form[field].$error !== 'undefined') {
                                return $scope.form[field].$error;
                            }
                            return null;
                        };

                        $scope.profile = new CompanyProfilePublic(controllerScope.data.profile);
                        $scope.save = function () {
                            $scope.form.submitted = true;
                            if ($scope.form.$valid) {
                                $scope.profile.$update().then(function (data) {
                                    $scope.data.profile = data;
                                    $scope.$root.$broadcast('profile:updated');
                                    modal.close();
                                });
                            }
                        };
                    }]
                });
                event.stopPropagation();
            });
        }
    };
}]);
